export default "__VITE_ASSET__b6a8becc__"